import { Button } from '@cluey/cluey-components';
import { useMemo, useState } from 'react';

import { Loader } from '../../../../components/Loader/Loader';
import { useSelectEnrolmentModal } from '../../../../components/Modals/SelectEnrolmentModal/SelectEnrolmentModal';
import useInvoiceHistoryQuery from '../../../../hooks/queries/useInvoiceHistoryQuery';
import { PATH_HUB_CR_PAYMENT_QUERY } from '../../../../util/pagePath';
import Invoice from '../Invoice/Invoice';

const PER_PAGE = 10;

const InvoicesList = () => {
  const { open, openModal, closeModal, SelectEnrolmentModal } = useSelectEnrolmentModal();
  const { mappedData: data, isLoading, error } = useInvoiceHistoryQuery();
  const [visibleCount, setVisibleCount] = useState(PER_PAGE);
  const invoiceHistory = data?.invoiceHistory;
  const pageInvoices = useMemo(() => {
    if (Array.isArray(invoiceHistory)) {
      return invoiceHistory.slice(0, visibleCount);
    }
    return [];
  }, [invoiceHistory, visibleCount]);

  return (
    <div>
      <SelectEnrolmentModal
        closeModal={closeModal}
        enrolmentLinkTo={(enrolment) => `${PATH_HUB_CR_PAYMENT_QUERY}?token=${enrolment.enrolmentId}`}
        open={open}
      />
      <h3 className="mb-0 pb-3 pt-6 font-display text-2xl font-bold">Invoice History</h3>
      {error && <div>{error}</div>}

      <ul className="m-0 p-0">
        {isLoading ? (
          <Loader size={10} />
        ) : !invoiceHistory?.length ? (
          <li>No invoices found</li>
        ) : (
          pageInvoices.map((invoice) => <Invoice key={invoice.invoiceNumber} invoice={invoice} onClick={openModal} />)
        )}
      </ul>
      {!!invoiceHistory?.length && visibleCount < invoiceHistory.length && (
        <div className="mt-4 flex justify-center">
          <Button
            appearance="reverse"
            type="button"
            className="text-grey-7 rounded-full border border-grey-2 bg-white px-4 py-2 shadow-sm transition-colors hover:bg-slate-1"
            onClick={() => setVisibleCount((count) => count + PER_PAGE)}
          >
            Load more
          </Button>
        </div>
      )}
    </div>
  );
};

export default InvoicesList;
